import { tsValidateBoolean, tsValidateDynamicObject, tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ModifiableProps = {
    step: tsValidateString(),
    title: tsValidateString(),
    body: tsValidateString(),
    isMutable: tsValidateBoolean(),
    aliases: tsValidateDynamicObject(tsValidateString(), tsValidateString())
};
const Validator_GeneratedProps = {};
export const DBDef_LogTemplate = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'log-templates',
    entityName: 'LogTemplate',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'log-template'
    },
    backend: {
        name: 'log-templates'
    },
};
//# sourceMappingURL=db-def.js.map